import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `security`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'company',
  permission: 'security.manage',
} satisfies AdminPageAccessRule;
